import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_workbox_08953ebd from 'nuxt_plugin_workbox_08953ebd' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_log_a536d75a from 'nuxt_plugin_log_a536d75a' // Source: ./log.js (mode: 'all')
import nuxt_plugin_pluginrouting_d42c3576 from 'nuxt_plugin_pluginrouting_d42c3576' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_103cd76c from 'nuxt_plugin_pluginmain_103cd76c' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_sentryserver_5f870ca5 from 'nuxt_plugin_sentryserver_5f870ca5' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_0c64c9c6 from 'nuxt_plugin_sentryclient_0c64c9c6' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_axios_52fcbde1 from 'nuxt_plugin_axios_52fcbde1' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_checkWhitePage_0e7ffdde from 'nuxt_plugin_checkWhitePage_0e7ffdde' // Source: ../plugins/checkWhitePage.js (mode: 'all')
import nuxt_plugin_vueinject_1aea0b89 from 'nuxt_plugin_vueinject_1aea0b89' // Source: ../plugins/vue-inject.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_vant_6a878e27 from 'nuxt_plugin_vant_6a878e27' // Source: ../plugins/vant (mode: 'all')
import nuxt_plugin_gaclient_594060ae from 'nuxt_plugin_gaclient_594060ae' // Source: ../plugins/ga.client.js (mode: 'client')
import nuxt_plugin_hiveclient_6cd2ab78 from 'nuxt_plugin_hiveclient_6cd2ab78' // Source: ../plugins/hive.client.js (mode: 'client')
import nuxt_plugin_switchLangclient_1af0c1d4 from 'nuxt_plugin_switchLangclient_1af0c1d4' // Source: ../plugins/switchLang.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"BIGO LIVE - Broadcast & Explore Live Streaming","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5, minimum-scale=1"},{"name":"google-site-verification","content":"fK_CSs0lIl35O-9gx32fS7uzMbj8VhN9OgHhXdnu4fc"},{"hid":"title","name":"title","content":"BIGO LIVE - Broadcast & Explore Live Streaming"},{"hid":"keywords","name":"keywords","content":"LIVE broadcasts,BIGO LIVE,Game broadcasting,video streaming"},{"hid":"description","name":"description","content":"BIGO LIVE is a leading live streaming community to show your talents and make friends from all around the world. Come and go!"},{"hid":"og:title","property":"og:title","content":"BIGO LIVE - Broadcast & Explore Live Streaming"},{"hid":"og:description","property":"og:description","content":"BIGO LIVE is a leading live streaming community to show your talents and make friends from all around the world. Come and go!"},{"hid":"al:ios:url","property":"al:ios:url","content":"bigolive:\u002F\u002Flivevideoshow?visitor=1"},{"hid":"al:android:url","property":"al:android:url","content":"bigolive:\u002F\u002Flivevideoshow?visitor=1"},{"hid":"al:web:url","property":"al:web:url","content":"https:\u002F\u002Fwww.bigo.tv"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fstatic-web.likeevideo.com\u002Fas\u002Fbigo-static\u002Fwww.bigo.tv\u002Fimg\u002Flogo_icon.png"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fwww.bigo.tv"},{"hid":"og:site_name","property":"og:site_name","content":"www.bigo.tv"},{"hid":"al:ios:app_store_id","property":"al:ios:app_store_id","content":"1077137248"},{"hid":"al:ios:app_name","property":"al:ios:app_name","content":"BIGO LIVE"},{"hid":"al:android:package","property":"al:android:package","content":"sg.bigo.live"},{"hid":"al:android:app_name","property":"al:android:app_name","content":"BIGO LIVE"},{"hid":"apple-mobile-web-app-title","property":"apple-mobile-web-app-title","content":"BIGO LIVE"},{"hid":"og:type","property":"og:type","content":"video.other"},{"hid":"twitter:card","name":"twitter:card","content":"summary"},{"hid":"twitter:site","name":"twitter:site","content":"@BIGOLIVEapp"},{"hid":"twitter:title","name":"twitter:title","content":"BIGO LIVE - Broadcast & Explore Live Streaming"},{"hid":"twitter:description","name":"twitter:description","content":"BIGO LIVE is a leading live streaming community to show your talents and make friends from all around the world. Come and go!"},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fstatic-web.likeevideo.com\u002Fas\u002Fbigo-static\u002Fwww.bigo.tv\u002Fimg\u002Flogo_icon.png"},{"hid":"twitter:url","name":"twitter:url","content":"https:\u002F\u002Fwww.bigo.tv"},{"http-equiv":"Content-Security-Policy","content":"upgrade-insecure-requests"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"BIGO LIVE - Broadcast & Explore Live Streaming"},{"hid":"author","name":"author","content":"jiurigege"},{"hid":"theme-color","name":"theme-color","content":"#f5f7fa"}],"link":[{"rel":"apple-touch-icon","href":"https:\u002F\u002Fstatic-web.likeevideo.com\u002Fas\u002Fbigo-static\u002Fwww.bigo.tv\u002Fbark_login\u002Fapple-touch-icon.png"},{"hid":"favicon","rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","hid":"videojscss","href":"https:\u002F\u002Fstatic-web.likeevideo.com\u002Fas\u002Fbigo-static\u002Fwww.bigo.tv\u002Fvideo.js\u002Fvideo-js.min.css","head":true},{"rel":"manifest","href":"https:\u002F\u002Fstatic-fed.piojm.tech\u002Flive\u002Fas\u002Fbigo_tv_assets\u002Fdist-dir\u002Fdist\u002Fclient\u002Fmanifest.3abf7a3f.json"},{"rel":"shortcut icon","href":"https:\u002F\u002Fstatic-web.bigolive.tv\u002Fas\u002Fbigo-static\u002Fwww.bigo.tv\u002Fimg\u002Flogo_icon.png"}],"script":[{"hid":"assets-load-monitor","src":"https:\u002F\u002Fstatic-web.likeevideo.com\u002Fas\u002Fbigo-static\u002Fwww.bigo.tv\u002Fmonitor\u002Fassets-load-monitor-2.5.6.min.js","head":true},{"hid":"videojs","src":"https:\u002F\u002Fstatic-web.likeevideo.com\u002Fas\u002Fbigo-static\u002Fwww.bigo.tv\u002Fvideo.js\u002Fvideo.min.js","head":true,"defer":true},{"hid":"captcha","src":"https:\u002F\u002Fstatic-web.hzmk.site\u002Fas\u002Fbigo-static\u002Fwww.bigo.tv\u002Fcdn\u002Fbigo-captcha.min.js","head":true,"defer":true},{"hid":"qrcodejs","src":"https:\u002F\u002Fstatic-web.likeevideo.com\u002Fas\u002Fbigo-static\u002Fcdn\u002Fqrcode\u002Fqrcode.min.js","head":true,"defer":true},{"hid":"devicevjs","src":"https:\u002F\u002Fstatic-web.likeevideo.com\u002Fas\u002Fbigo-static\u002Fcdn\u002Fdevicev\u002Fdevicev1.4.js","head":true,"defer":true},{"hid":"ga","src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=UA-167434529-1","body":true,"defer":true,"onload":"\n          window.dataLayer = window.dataLayer || [];\n          window.gtag = window.gtag || function gtag() {window.dataLayer.push(arguments);};\n          gtag('js', new Date());\n\n          gtag('config', 'UA-167434529-1');\n        "},{"hid":"clarityjs","src":"https:\u002F\u002Fstatic-web.likeevideo.com\u002Fas\u002Fbigo-static\u002Fwww.bigo.tv\u002Fdist\u002Fclarity.js","body":true,"defer":true}],"style":[],"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__bigolive_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__BIGOLIVE__ && window.__BIGOLIVE__.state) {
      store.replaceState(window.__BIGOLIVE__.state)
    }
  }

  // Plugin execution

  if (process.client && typeof nuxt_plugin_workbox_08953ebd === 'function') {
    await nuxt_plugin_workbox_08953ebd(app.context, inject)
  }

  if (typeof nuxt_plugin_log_a536d75a === 'function') {
    await nuxt_plugin_log_a536d75a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_d42c3576 === 'function') {
    await nuxt_plugin_pluginrouting_d42c3576(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_103cd76c === 'function') {
    await nuxt_plugin_pluginmain_103cd76c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_5f870ca5 === 'function') {
    await nuxt_plugin_sentryserver_5f870ca5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_0c64c9c6 === 'function') {
    await nuxt_plugin_sentryclient_0c64c9c6(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_52fcbde1 === 'function') {
    await nuxt_plugin_axios_52fcbde1(app.context, inject)
  }

  if (typeof nuxt_plugin_checkWhitePage_0e7ffdde === 'function') {
    await nuxt_plugin_checkWhitePage_0e7ffdde(app.context, inject)
  }

  if (typeof nuxt_plugin_vueinject_1aea0b89 === 'function') {
    await nuxt_plugin_vueinject_1aea0b89(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_vant_6a878e27 === 'function') {
    await nuxt_plugin_vant_6a878e27(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gaclient_594060ae === 'function') {
    await nuxt_plugin_gaclient_594060ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hiveclient_6cd2ab78 === 'function') {
    await nuxt_plugin_hiveclient_6cd2ab78(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_switchLangclient_1af0c1d4 === 'function') {
    await nuxt_plugin_switchLangclient_1af0c1d4(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
